<template>
  <div>
    <!-- 抽屉式弹窗 -->
    <el-drawer
      :visible.sync="dialogVisible"
      :with-header="false"
      direction="rtl"
      size="90%"
      :before-close="handleClose"
      :show-close="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      custom-class="custom-drawer"
    >
      <div class="card-container">
        <div class="card-left">
          <div class="titler">客户经营管理信息</div>
          <div class="titlxtd noborder marbo10">基本信息</div>
          <el-form
            ref="formone"
            :model="subData"
            :rules="rules"
            label-width="100px"
            :inline="true"
          >
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item label="证件类型：" prop="certificateType">
                  <el-select
                    v-model="subData.certificateType"
                    placeholder="请选择证件类型"
                    disabled
                    clearable
                  >
                    <el-option label="营业执照" :value="1"></el-option>
                    <el-option label="医疗执业许可证" :value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="证件编号：" prop="certificateNumber">
                  <el-input
                    v-model="subData.certificateNumber"
                    placeholder="请输入证件编号"
                    disabled
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="企业名称：" prop="enterprise">
                  <el-input
                    v-model="subData.enterprise"
                    placeholder="请输入企业名称"
                    disabled
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="entryMode !== 'snapshot'">
                <el-form-item label="单位内码：" prop="erpCode">
                  <el-input
                    v-model="subData.erpCode"
                    placeholder="请输入单位内码"
                    disabled
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12" v-else>
                <div style="height: 52px"></div>
              </el-col>
              <el-col :span="12">
                <el-form-item label="经营状态：" prop="businessStatus">
                  <el-select
                    v-model="subData.businessStatus"
                    placeholder="请选择经营状态"
                    :disabled="!isEditing"
                    clearable
                  >
                    <el-option label="正常" :value="1"></el-option>
                    <el-option label="注销" :value="2"></el-option>
                    <el-option label="吊销" :value="3"></el-option>
                    <el-option label="歇业" :value="4"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="地区：" prop="province" required>
                  <el-cascader
                    v-model="areaArr"
                    :disabled="!isEditing"
                    :options="AreaList"
                    :props="propsValue"
                    clearable
                    placeholder="请选择所在地区"
                    @change="onAreaChange"
                  ></el-cascader>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="注册地址：" prop="address">
                  <el-input
                    v-model="subData.address"
                    placeholder="请输入注册地址"
                    clearable
                    :disabled="!isEditing"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="交易关系：" prop="isSale">
                  <el-checkbox-group
                    v-model="subData.isSale"
                    :disabled="!isEditing"
                  >
                    <el-checkbox :label="1">销售</el-checkbox>
                    <el-checkbox :label="2">采购</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="12">
                <el-form-item label="拼音码：" prop="pinyinCode">
                  <el-input
                    v-model="subData.pinyinCode"
                    placeholder="请输入拼音码"
                    :disabled="!isEditing"
                    clearable
                  />
                </el-form-item>
              </el-col> -->
              <el-col :span="12">
                <el-form-item label="法人：" prop="legalEntity">
                  <el-input
                    v-model="subData.legalEntity"
                    placeholder="请输入法人"
                    :disabled="!isEditing"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="负责人：" prop="director">
                  <el-input
                    v-model="subData.director"
                    placeholder="请输入负责人"
                    :disabled="!isEditing"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="客户类别：" prop="unitType">
                  <el-select
                    @change="syncChainHeadquarterVisibility"
                    v-model="subData.unitType"
                    placeholder="请选择客户类别"
                    clearable
                    filterable
                    :disabled="!isEditing"
                  >
                    <el-option
                      v-for="item in customerCategoryOptions"
                      :key="item.id"
                      :label="item.typeName"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="isChainCustomer">
                <el-form-item label="连锁总部：" prop="chainHeadquarter">
                  <div class="chain-headquarter-field">
                    <el-select
                      v-model="subData.chainHeadquarter"
                      placeholder="请选择客户所属的连锁总部"
                      clearable
                      filterable
                      :disabled="!isEditing"
                      class="chain-headquarter-select"
                    >
                      <el-option
                        v-for="item in chainHeadquarterOptions"
                        :key="item.id"
                        :label="item.chainHeadquarter"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                    <el-button
                      v-if="isEditing"
                      type="text"
                      class="chain-headquarter-add-btn"
                      @click="openChainHeadquarterDialog"
                    >
                      +添加
                    </el-button>
                  </div>
                </el-form-item>
              </el-col>

              <!-- 客户备注使用 24 栅格，占满整行 -->
              <el-col :span="24">
                <el-form-item
                  label="客户备注："
                  prop="customerRemark"
                  class="full-width-item"
                >
                  <el-input
                    style="width: 100%"
                    v-model="subData.customerRemark"
                    placeholder="请输入客户备注描述"
                    type="textarea"
                    :rows="4"
                    maxlength="100"
                    show-word-limit
                    clearable
                    :disabled="!isEditing"
                  />
                </el-form-item>
              </el-col>
              <!-- 注释：非必填，与客户备注同样占满整行 -->
              <el-col :span="24">
                <el-form-item
                  label="注释："
                  prop="annotation"
                  class="full-width-item"
                >
                  <el-input
                    style="width: 100%"
                    v-model="subData.annotation"
                    placeholder="请输入注释"
                    type="textarea"
                    :rows="4"
                    maxlength="100"
                    show-word-limit
                    clearable
                    :disabled="!isEditing"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div class="delegation-section">
            <div class="section-title">
              <div class="title">
                <!-- <i class="el-icon-document"></i> -->
                <span>委托信息</span>
                <span class="badge"
                  >{{ (subData.authorizationInfo || []).length }}条</span
                >
              </div>
              <div class="actions">
                <el-button
                  v-if="isEditing"
                  size="mini"
                  type="primary"
                  class="btn-sm btn-add"
                  @click="addAuthorizationInfo"
                >
                  添 加
                </el-button>
                <el-button
                  v-if="isEditing"
                  size="mini"
                  class="btn-sm btn-replace"
                  @click="replaceAuthorizationInfo"
                >
                  替 换
                </el-button>
              </div>
            </div>

            <div class="delegation-list" v-loading="LoadingWeituo">
              <div
                v-for="(row, idx) in subData.authorizationInfo"
                :key="getAuthorizationKey(row) || idx"
                class="card-item"
              >
                <div class="card-top-row">
                  <div class="card-top-left">
                    <span
                      class="tag-badge"
                      :class="
                        row.principalType == 1
                          ? 'tag-update'
                          : row.principalType == 2
                          ? 'tag-new'
                          : 'hidden'
                      "
                    >
                      {{
                        row.principalType == 1
                          ? "更新"
                          : row.principalType == 2
                          ? "新增"
                          : ""
                      }}
                    </span>
                    <span class="card-name">{{
                      row.principalName || "--"
                    }}</span>
                    <span class="id-inline">
                      <span class="label">ID:</span>
                      <span class="value">{{
                        getAuthorizationInfoId(row) || "--"
                      }}</span>
                    </span>
                  </div>
                  <div class="card-top-right">
                    <span class="weak-item">
                      <span class="label">委托抬头</span>
                      <span
                        class="header-tag"
                        :class="row.isHasHeader == 1 ? 'has' : 'none'"
                      >
                        {{ row.isHasHeader == 1 ? "有" : "无" }}
                      </span>
                    </span>
                    <span class="weak-item">
                      <span class="label">委托企业</span>
                      <span class="value">{{ row.businessName || "--" }}</span>
                    </span>
                  </div>
                </div>

                <div class="info-row-strong">
                  <span class="label">委托类型：</span>
                  <span class="value">{{
                    row.delegateType == 1
                      ? "法人"
                      : row.delegateType == 2
                      ? "采购员"
                      : "--"
                  }}</span>
                  <span class="label">身份证：</span>
                  <span class="value">{{ row.idNumber || "--" }}</span>
                </div>

                <div class="status-row">
                  <div class="status-block">
                    <div class="status-title">采购</div>
                    <div class="status-content">
                      <span
                        class="status-tag"
                        :class="
                          row.purchaseStatus == 1 ? 'enabled' : 'disabled'
                        "
                      >
                        {{ row.purchaseStatus == 1 ? "启用" : "禁用" }}
                      </span>
                      <span
                        class="status-tag"
                        :class="
                          row.purchaseExpiryDate
                            ? row.purchaseExpiryDate == '9999-12-31' ||
                              row.purchaseExpiryDate == '2999-12-31'
                              ? 'permanent'
                              : 'date'
                            : 'empty'
                        "
                      >
                        <template v-if="row.purchaseExpiryDate">{{
                          row.purchaseExpiryDate | formatDate
                        }}</template>
                        <template v-else>--</template>
                      </span>
                    </div>
                  </div>
                  <div class="status-block">
                    <div class="status-title">含特</div>
                    <div class="status-content">
                      <span
                        class="status-tag"
                        :class="
                          row.ephedrineStatus == 1 ? 'enabled' : 'disabled'
                        "
                      >
                        {{ row.ephedrineStatus == 1 ? "启用" : "禁用" }}
                      </span>
                      <span
                        class="status-tag"
                        :class="
                          row.ephedrineExpiryDate
                            ? row.ephedrineExpiryDate == '9999-12-31' ||
                              row.ephedrineExpiryDate == '2999-12-31'
                              ? 'permanent'
                              : 'date'
                            : 'empty'
                        "
                      >
                        <template v-if="row.ephedrineExpiryDate">{{
                          row.ephedrineExpiryDate | formatDate
                        }}</template>
                        <template v-else>--</template>
                      </span>
                    </div>
                  </div>
                  <div class="status-block">
                    <div class="status-title">血液</div>
                    <div class="status-content">
                      <span
                        class="status-tag"
                        :class="row.bloodStatus == 1 ? 'enabled' : 'disabled'"
                      >
                        {{ row.bloodStatus == 1 ? "启用" : "禁用" }}
                      </span>
                      <span
                        class="status-tag"
                        :class="
                          row.bloodExpiryDate
                            ? row.bloodExpiryDate == '9999-12-31' ||
                              row.bloodExpiryDate == '2999-12-31'
                              ? 'permanent'
                              : 'date'
                            : 'empty'
                        "
                      >
                        <template v-if="row.bloodExpiryDate">{{
                          row.bloodExpiryDate | formatDate
                        }}</template>
                        <template v-else>--</template>
                      </span>
                    </div>
                  </div>
                </div>

                <div class="card-footer">
                  <div class="footer-id-contact">
                    <div v-if="entryMode !== 'snapshot'" class="id-block">
                      <span class="label">联系人内码</span>
                      <span class="value">{{ row.contactsCode || "--" }}</span>
                    </div>
                  </div>
                  <div class="card-actions" v-if="isEditing">
                    <button
                      class="action-btn"
                      @click="openDelegateDialog(row, idx)"
                    >
                      编辑
                    </button>
                    <button
                      class="action-btn danger"
                      @click="removeAuthorizationInfo(row, idx)"
                    >
                      移除
                    </button>
                  </div>
                </div>
              </div>

              <div
                v-if="
                  !LoadingWeituo &&
                  (!subData.authorizationInfo ||
                    subData.authorizationInfo.length === 0)
                "
                class="delegation-empty"
              >
                暂无委托信息
              </div>
            </div>
          </div>
          <div
            v-if="newAuthorizationList.length && entryMode == 'edit'"
            class="new-authorization-panel"
          >
            <div class="new-section-divider">新增的委托人</div>
            <div class="alert-banner-simple">
              <span class="el-icon-warning alert-icon"></span>
              <div class="alert-text">
                识别到<strong>{{ newAuthorizationList.length }}</strong
                >个新增的委托人，请选择相关操作，若不操作将自动忽略
              </div>
            </div>

            <div class="delegation-list new-delegation-list">
              <div
                v-for="(row, idx) in newAuthorizationList"
                :key="getAuthorizationKey(row) || 'new-' + idx"
                class="card-item card-new"
              >
                <div class="card-top-row">
                  <div class="card-top-left">
                    <span
                      class="tag-badge"
                      :class="
                        row.principalType == 1
                          ? 'tag-update'
                          : row.principalType == 2
                          ? 'tag-new'
                          : 'hidden'
                      "
                    >
                      {{
                        row.principalType == 1
                          ? "更新"
                          : row.principalType == 2
                          ? "新增"
                          : ""
                      }}
                    </span>
                    <span class="card-name">{{
                      row.principalName || "--"
                    }}</span>
                  </div>
                  <div class="card-top-right">
                    <span
                      class="header-tag"
                      :class="row.isHasHeader == 1 ? 'has' : 'none'"
                    >
                      {{ row.isHasHeader == 1 ? "有抬头" : "无抬头" }}
                    </span>
                    <span class="weak-item">
                      <span class="label">委托企业</span>
                      <span class="value">{{ row.businessName || "--" }}</span>
                    </span>
                  </div>
                </div>

                <div class="info-row-strong">
                  <span class="label">委托类型</span>
                  <span class="value">{{
                    row.delegateType == 1
                      ? "法人"
                      : row.delegateType == 2
                      ? "采购员"
                      : "--"
                  }}</span>
                  <span class="label">身份证</span>
                  <span class="value">{{ row.idNumber || "--" }}</span>
                </div>

                <div class="status-row">
                  <div class="status-block">
                    <div class="status-title">采购</div>
                    <div class="status-content">
                      <span
                        class="status-tag"
                        :class="
                          row.purchaseStatus == 1 ? 'enabled' : 'disabled'
                        "
                      >
                        {{ row.purchaseStatus == 1 ? "启用" : "禁用" }}
                      </span>
                      <span
                        class="status-tag"
                        :class="
                          row.purchaseExpiryDate
                            ? row.purchaseExpiryDate == '9999-12-31' ||
                              row.purchaseExpiryDate == '2999-12-31'
                              ? 'permanent'
                              : 'date'
                            : 'empty'
                        "
                      >
                        <template v-if="row.purchaseExpiryDate">{{
                          row.purchaseExpiryDate | formatDate
                        }}</template>
                        <template v-else>--</template>
                      </span>
                    </div>
                  </div>
                  <div class="status-block">
                    <div class="status-title">含特</div>
                    <div class="status-content">
                      <span
                        class="status-tag"
                        :class="
                          row.ephedrineStatus == 1 ? 'enabled' : 'disabled'
                        "
                      >
                        {{ row.ephedrineStatus == 1 ? "启用" : "禁用" }}
                      </span>
                      <span
                        class="status-tag"
                        :class="
                          row.ephedrineExpiryDate
                            ? row.ephedrineExpiryDate == '9999-12-31' ||
                              row.ephedrineExpiryDate == '2999-12-31'
                              ? 'permanent'
                              : 'date'
                            : 'empty'
                        "
                      >
                        <template v-if="row.ephedrineExpiryDate">{{
                          row.ephedrineExpiryDate | formatDate
                        }}</template>
                        <template v-else>--</template>
                      </span>
                    </div>
                  </div>
                  <div class="status-block">
                    <div class="status-title">血液</div>
                    <div class="status-content">
                      <span
                        class="status-tag"
                        :class="row.bloodStatus == 1 ? 'enabled' : 'disabled'"
                      >
                        {{ row.bloodStatus == 1 ? "启用" : "禁用" }}
                      </span>
                      <span
                        class="status-tag"
                        :class="
                          row.bloodExpiryDate
                            ? row.bloodExpiryDate == '9999-12-31' ||
                              row.bloodExpiryDate == '2999-12-31'
                              ? 'permanent'
                              : 'date'
                            : 'empty'
                        "
                      >
                        <template v-if="row.bloodExpiryDate">{{
                          row.bloodExpiryDate | formatDate
                        }}</template>
                        <template v-else>--</template>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="flex_justify marbo10 mar20">
            <div class="titlxtd noborder">收货信息</div>
            <el-button v-if="isEditing" @click="openConsigneeDialog">
              添 加
            </el-button>
          </div>
          <!-- 收货信息 -->
          <div class="table-Onsearch">
            <el-table
              v-loading="LoadingSouhe"
              :data="subData.receivingAddress"
              border
              max-height="250px"
            >
              <el-table-column
                prop="consigneeWarehouse"
                label="收货仓库"
                align="center"
              />
              <el-table-column prop="consignee" label="收货人" align="center" />
              <el-table-column
                prop="consigneeMobile"
                label="联系电话"
                align="center"
              />
              <el-table-column
                prop="consigneeAddress"
                label="收货地址"
                align="center"
              />
              <el-table-column
                prop="createTime"
                label="添加日期"
                align="center"
              />
              <el-table-column
                v-if="isEditing"
                label="操作"
                width="80"
                align="center"
                fixed="right"
              >
                <template slot-scope="{ $index }">
                  <span class="btsed" @click="removeConsignee($index)">
                    删除
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 经营范围 -->
          <div class="titlxtd noborder marbo10 mar20">经营范围</div>
          <div style="padding-right: 20px">
            <el-tree
              ref="tree"
              :data="treeData"
              show-checkbox
              node-key="businessScopeId"
              :props="defaultProps"
              check-strictly
              @check="handleScopeCheck"
            >
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <!-- 有子级的父节点：勾选框右侧一键勾选/取消子级 -->
                <span class="scope-tree-label">{{ node.label }}</span>
                <span
                  v-if="isEditing && hasScopeChildren(data)"
                  class="scope-check-children-btn btsed"
                  @click.stop="handleCheckAllChildren(data)"
                >
                  一键勾选子级
                </span>
              </span>
            </el-tree>
          </div>
        </div>
        <div class="card-right">
          <div class="Onseter">
            <div
              v-for="(v, i) in subData.auditQualificationList"
              :key="i"
              @click="ChoiceType = v.id"
              class="NonActive onset-item"
              :class="[ChoiceType === v.id ? 'OnsetActive' : '']"
            >
              <span class="onset-badges">
                <span
                  v-if="showIsChangedStyle && v.isChanged == 1"
                  class="onset-badge onset-badge-update"
                >
                  更新
                </span>
                <span
                  v-if="showIsChangedStyle && v.isChanged == 2"
                  class="onset-badge onset-badge-update"
                >
                  新增
                </span>
                <span
                  v-if="v.isExpired == 1"
                  class="onset-badge onset-badge-expired"
                >
                  已过期
                </span>
              </span>
              <span class="onset-text">{{ v.templateName }}</span>
            </div>
          </div>
          <div class="rigtContainer">
            <div class="righTop">
              <div :key="viewerHostKey" style="height: 400px">
                <template
                  v-if="currentQualification && qualificationImgList.length"
                >
                  <viewer :key="viewerKey" :options="viewerOptions">
                    <img
                      v-for="(url, idx) in qualificationImgList"
                      :key="idx"
                      :src="url"
                      alt=""
                      :style="{
                        height: '400px',
                        display: idx === 0 ? 'block' : 'none',
                      }"
                    />
                  </viewer>
                </template>
              </div>
              <div class="shixian"></div>
            </div>
            <div class="righBottom">
              <div style="width: 95%; padding-left: 1%; padding-top: 10px">
                <el-form
                  v-if="currentQualification"
                  ref="formtwo"
                  :model="currentQualification"
                  label-width="170px"
                >
                  <el-form-item
                    v-for="(
                      item, index
                    ) in currentQualification.auditQualificationItemList"
                    :key="item.templateParamId"
                    :label="item.templateParamName"
                    :prop="
                      'auditQualificationItemList.' +
                      index +
                      '.templateParamValue'
                    "
                    :required="item.isRequired == 1"
                    :rules="
                      item.isRequired == 1
                        ? [
                            {
                              required: true,
                              message: '请填写' + item.templateParamName,
                              trigger:
                                item.templateParamType == 1 ||
                                item.templateParamType == 4
                                  ? 'change'
                                  : 'blur',
                            },
                          ]
                        : []
                    "
                    :class="
                      showIsChangedStyle && item.isChanged == 1
                        ? 'changed-field'
                        : ''
                    "
                  >
                    <div class="field-wrapper">
                      <!-- 1: 时间, 2: 文本, 3: 省市区, 4: 下拉选择框 -->
                      <!-- <el-date-picker
                        v-if="item.templateParamType == 1"
                        v-model="item.templateParamValue"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="请选择日期"
                        style="width: 100%"
                        disabled
                        :class="
                          showIsChangedStyle && item.isChanged == 1
                            ? 'changed-input'
                            : ''
                        "
                      />
                      <el-input
                        v-else-if="item.templateParamType == 2"
                        v-model="item.templateParamValue"
                        :placeholder="'请输入' + item.templateParamName"
                        disabled
                        :class="
                          showIsChangedStyle && item.isChanged == 1
                            ? 'changed-input'
                            : ''
                        "
                      />
                      <el-input
                        v-else-if="item.templateParamType == 3"
                        v-model="item.templateParamValue"
                        placeholder="请输入省市区"
                        disabled
                        :class="
                          showIsChangedStyle && item.isChanged == 1
                            ? 'changed-input'
                            : ''
                        "
                      />
                      <el-select
                        v-else-if="item.templateParamType == 4"
                        v-model="item.templateParamValue"
                        placeholder="请选择"
                        style="width: 100%"
                        disabled
                        :class="
                          showIsChangedStyle && item.isChanged == 1
                            ? 'changed-input'
                            : ''
                        "
                      >
                      </el-select>
                      <el-input
                        v-else="item.templateParamType == 2"
                        v-model="item.templateParamValue"
                        :placeholder="'请输入' + item.templateParamName"
                        disabled
                        :class="
                          showIsChangedStyle && item.isChanged == 1
                            ? 'changed-input'
                            : ''
                        "
                      /> -->
                      <div
                        :class="
                          showIsChangedStyle && item.isChanged == 1
                            ? 'changed-text'
                            : 'Ontext'
                        "
                        :style="
                          item.templateParamValue.split(' ').join('')
                            ? ''
                            : 'height: 32px;line-height: 32px;'
                        "
                      >
                        {{ item.templateParamValue }}
                      </div>
                      <span
                        v-if="showIsChangedStyle && item.isChanged == 1"
                        class="update-badge"
                      >
                        更新
                      </span>
                    </div>
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </div>
        </div>
        <!-- 底部操作栏固定在抽屉底部 -->
        <div slot="footer" class="dialog-footer">
          <template v-if="isEditing">
            <el-button @click="handleCancel">{{ cancelText }}</el-button>
            <el-button
              type="primary"
              :loading="btnLoading"
              @click="handleSubmit"
            >
              确认提交
            </el-button>
          </template>
          <template v-else>
            <template v-if="entryMode === 'view'">
              <el-button @click="handleClose">关 闭</el-button>
              <el-button @click="openShareDialog">共享发送</el-button>
              <el-button @click="openSyncErpDialog">同步ERP</el-button>
              <el-button type="primary" @click="enterEditMode">编 辑</el-button>
            </template>
            <template v-else-if="entryMode === 'audit'">
              <el-button @click="handleClose">关 闭</el-button>
              <el-button @click="auditReject">不通过</el-button>
              <el-button
                type="primary"
                :loading="btnLoading"
                @click="auditApprove"
              >
                通 过
              </el-button>
            </template>
            <template v-else>
              <el-button @click="handleClose">关 闭</el-button>
            </template>
          </template>
        </div>
      </div>
    </el-drawer>

    <el-dialog
      title="添加收货人"
      :visible.sync="consigneeDialogVisible"
      width="500px"
      :close-on-click-modal="false"
    >
      <el-form
        ref="consigneeFormRef"
        :model="consigneeForm"
        :rules="consigneeRules"
        label-width="100px"
      >
        <el-form-item label="收货仓库：" prop="consigneeWarehouse">
          <el-input
            v-model="consigneeForm.consigneeWarehouse"
            placeholder="请输入收货仓库名称"
            clearable
          />
        </el-form-item>
        <el-form-item label="收货人：" prop="consignee">
          <el-input
            v-model="consigneeForm.consignee"
            placeholder="请输入收货人姓名"
            clearable
          />
        </el-form-item>
        <el-form-item label="联系电话：" prop="consigneeMobile">
          <el-input
            v-model="consigneeForm.consigneeMobile"
            placeholder="请输入收货人电话"
            clearable
          />
        </el-form-item>
        <el-form-item label="收货地址：" prop="consigneeAddress">
          <el-input
            v-model="consigneeForm.consigneeAddress"
            placeholder="请输入收货地址"
            clearable
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeConsigneeDialog">取 消</el-button>
        <el-button type="primary" @click="confirmConsignee">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="编辑委托人"
      :visible.sync="delegateDialogVisible"
      width="950px"
      :close-on-click-modal="false"
    >
      <el-form
        ref="delegateFormRef"
        :model="delegateForm"
        :rules="delegateRules"
        label-width="140px"
      >
        <el-row :gutter="20" class="eldelefs">
          <el-col :span="12">
            <el-form-item label="委托抬头：" prop="isHasHeader">
              <el-radio-group
                v-model="delegateForm.isHasHeader"
                @change="onDelegateStatusChange('header')"
              >
                <el-radio :label="1">有抬头</el-radio>
                <el-radio :label="2">无抬头</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="delegateForm.isHasHeader == 1">
            <el-form-item label="委托企业：" prop="businessName">
              <el-input
                v-model="delegateForm.businessName"
                placeholder="请输入委托企业名称"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12" v-else>
            <div style="height: 52px"></div>
          </el-col>
          <el-col :span="12">
            <el-form-item label="委托人姓名：" prop="principalName">
              <el-input
                v-model="delegateForm.principalName"
                placeholder="请输入委托人姓名"
                clearable
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证号码：" prop="idNumber">
              <el-input
                v-model="delegateForm.idNumber"
                placeholder="请输入身份证号码"
                clearable
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="委托类型：" prop="delegateType" class="fx-1">
              <el-select
                v-model="delegateForm.delegateType"
                placeholder="请选择委托类型"
                clearable
                style="width: 100%"
              >
                <el-option label="法人" :value="1" />
                <el-option label="采购员" :value="2" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <div style="height: 52px"></div>
          </el-col>
          <el-col :span="12">
            <el-form-item label="采购委托状态：" prop="purchaseStatus">
              <el-select
                v-model="delegateForm.purchaseStatus"
                placeholder="请选择采购委托状态"
                clearable
                style="width: 100%"
                @change="onDelegateStatusChange('purchase')"
              >
                <el-option label="开启" :value="1" />
                <el-option label="关闭" :value="2" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10" v-if="delegateForm.purchaseStatus == 1">
            <el-form-item
              label="采购委托有效期："
              prop="purchaseExpiryDate"
              :rules="[
                {
                  required: true,
                  message: '请选择采购委托有效期',
                  trigger: 'change',
                },
              ]"
            >
              <el-date-picker
                v-model="delegateForm.purchaseExpiryDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="请选择日期"
                style="width: 100%"
                :disabled="delegateForm.purchaseLongTerm"
              />
            </el-form-item>
          </el-col>
          <el-col :span="2" v-if="delegateForm.purchaseStatus == 1">
            <el-form-item label-width="0">
              <el-checkbox
                v-model="delegateForm.purchaseLongTerm"
                @change="onDelegateLongTermChange('purchase')"
              >
                长期
              </el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-else>
            <div style="height: 52px"></div>
          </el-col>
          <el-col :span="12">
            <el-form-item label="含特委托状态：" prop="ephedrineStatus">
              <el-select
                v-model="delegateForm.ephedrineStatus"
                placeholder="请选择含特委托状态"
                clearable
                style="width: 100%"
                @change="onDelegateStatusChange('ephedrine')"
              >
                <el-option label="开启" :value="1" />
                <el-option label="关闭" :value="2" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10" v-if="delegateForm.ephedrineStatus == 1">
            <el-form-item
              label="含特委托有效期："
              prop="ephedrineExpiryDate"
              :rules="[
                {
                  required: true,
                  message: '请选择含特委托有效期',
                  trigger: 'change',
                },
              ]"
            >
              <el-date-picker
                v-model="delegateForm.ephedrineExpiryDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="请选择日期"
                style="width: 100%"
                :disabled="delegateForm.ephedrineLongTerm"
              />
            </el-form-item>
          </el-col>
          <el-col :span="2" v-if="delegateForm.ephedrineStatus == 1">
            <el-form-item label-width="0">
              <el-checkbox
                v-model="delegateForm.ephedrineLongTerm"
                @change="onDelegateLongTermChange('ephedrine')"
              >
                长期
              </el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-else>
            <div style="height: 52px"></div>
          </el-col>
          <el-col :span="12">
            <el-form-item label="血液委托状态：" prop="bloodStatus">
              <el-select
                v-model="delegateForm.bloodStatus"
                placeholder="请选择血液委托状态"
                clearable
                style="width: 100%"
                @change="onDelegateStatusChange('blood')"
              >
                <el-option label="开启" :value="1" />
                <el-option label="关闭" :value="2" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10" v-if="delegateForm.bloodStatus == 1">
            <el-form-item
              label="血液委托有效期："
              prop="bloodExpiryDate"
              :rules="[
                {
                  required: true,
                  message: '请选择血液委托有效期',
                  trigger: 'change',
                },
              ]"
            >
              <el-date-picker
                v-model="delegateForm.bloodExpiryDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="请选择日期"
                style="width: 100%"
                :disabled="delegateForm.bloodLongTerm"
              />
            </el-form-item>
          </el-col>
          <el-col :span="2" v-if="delegateForm.bloodStatus == 1">
            <el-form-item label-width="0">
              <el-checkbox
                v-model="delegateForm.bloodLongTerm"
                @change="onDelegateLongTermChange('blood')"
              >
                长期
              </el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-else>
            <div style="height: 52px"></div>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDelegateDialog">取 消</el-button>
        <el-button type="primary" @click="confirmDelegate">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="添加委托人"
      :visible.sync="addAuthorizationDialogVisible"
      width="1100px"
      :close-on-click-modal="false"
    >
      <el-table
        ref="addAuthorizationTable"
        :data="subData.unconfirmedAuthorizationInfo"
        border
        max-height="420px"
        @selection-change="onAddAuthorizationSelectionChange"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column label="标签" align="center" width="70">
          <template slot-scope="{ row }">
            <span
              class="delegate-tag"
              :class="row.principalType == 2 ? 'delegate-tag-new' : ''"
              v-if="row.principalType"
            >
              {{
                row.principalType == 1
                  ? "更新"
                  : row.principalType == 2
                  ? "新增"
                  : row.principalType == 3
                  ? "正常"
                  : "-"
              }}
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="authorizationInfoId" label="ID" align="center" />
        <el-table-column prop="principalName" label="姓名" align="center" />
        <el-table-column prop="delegateType" label="委托类型" align="center">
          <template slot-scope="{ row }">
            {{
              row.delegateType == 1
                ? "法人"
                : row.delegateType == 2
                ? "采购员"
                : ""
            }}
          </template>
        </el-table-column>
        <el-table-column prop="idNumber" label="身份证号码" align="center" />
        <el-table-column prop="isHasHeader" label="委托抬头" align="center">
          <template slot-scope="{ row }">
            {{ row.isHasHeader == 1 ? "有" : "无" }}
          </template>
        </el-table-column>
        <el-table-column prop="businessName" label="委托企业" align="center">
          <template slot-scope="{ row }">
            {{ row.businessName || "--" }}
          </template>
        </el-table-column>
        <el-table-column prop="purchaseStatus" label="采购状态" align="center">
          <template slot-scope="{ row }">
            {{ row.purchaseStatus == 1 ? "启用" : "禁用" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="purchaseExpiryDate"
          label="采购委托有效期"
          align="center"
        >
          <template slot-scope="{ row }">
            <span v-if="row.purchaseExpiryDate">
              {{ row.purchaseExpiryDate | formatDate }}
            </span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column prop="ephedrineStatus" label="含特状态" align="center">
          <template slot-scope="{ row }">
            {{ row.ephedrineStatus == 1 ? "启用" : "禁用" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="ephedrineExpiryDate"
          label="含特有效期"
          align="center"
        >
          <template slot-scope="{ row }">
            <span v-if="row.ephedrineExpiryDate">
              {{ row.ephedrineExpiryDate | formatDate }}
            </span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column prop="bloodStatus" label="血液状态" align="center">
          <template slot-scope="{ row }">
            {{ row.bloodStatus == 1 ? "启用" : "禁用" }}
          </template> </el-table-column
        >''
        <el-table-column
          prop="bloodExpiryDate"
          label="血液委托有效期"
          align="center"
        >
          <template slot-scope="{ row }">
            <span v-if="row.bloodExpiryDate">
              {{ row.bloodExpiryDate | formatDate }}
            </span>
            <span v-else>--</span>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeAddAuthorizationDialog">取 消</el-button>
        <el-button type="primary" @click="confirmAddAuthorizationDialog">
          添 加
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="委托人替换"
      :visible.sync="replaceAuthorizationDialogVisible"
      width="500px"
      :close-on-click-modal="false"
    >
      <div class="replace-authorization-form">
        <div class="replace-authorization-row">
          <div class="replace-authorization-label">原委托人：</div>
          <el-select
            v-model="replaceAuthorizationForm.oldIndex"
            placeholder="请选择原委托人"
            clearable
            style="width: 320px"
          >
            <el-option
              v-for="opt in oldAuthorizationOptions"
              :key="opt.entrustEnterpriseId"
              :label="formatAuthorizationOption(opt.row)"
              :value="opt.index"
            />
          </el-select>
        </div>
        <div class="replace-authorization-row">
          <div class="replace-authorization-label">新委托人：</div>
          <el-select
            v-model="replaceAuthorizationForm.newIndex"
            placeholder="请选择新委托人"
            clearable
            style="width: 320px"
          >
            <el-option
              v-for="(item, idx) in replaceNewAuthorizationList"
              :key="item.entrustEnterpriseId"
              :label="formatAuthorizationOption(item)"
              :value="idx"
            />
          </el-select>
        </div>
        <div class="replace-authorization-tip">
          提交后，新委托人相关信息将覆盖原委托人
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeReplaceAuthorizationDialog">取 消</el-button>
        <el-button type="primary" @click="confirmReplaceAuthorizationDialog">
          确 定
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="确认移除"
      :visible.sync="removeAuthorizationDialogVisible"
      width="420px"
      :close-on-click-modal="false"
    >
      <div class="remove-authorization-body">
        <i class="el-icon-warning-outline remove-authorization-icon" />
        <div class="remove-authorization-text">
          <div class="remove-authorization-title">
            确认移除委托人【{{ removingAuthorizationRowName }}】？
          </div>
          <div class="remove-authorization-tip">
            移除后，需要保存提交才会生效
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeRemoveAuthorizationDialog">取 消</el-button>
        <el-button type="primary" @click="confirmRemoveAuthorizationDialog">
          确 定
        </el-button>
      </div>
    </el-dialog>

    <!-- 新建连锁总部弹窗 -->
    <el-dialog
      title="新建"
      :visible.sync="chainHeadquarterDialogVisible"
      width="520px"
      :close-on-click-modal="false"
      @closed="closeChainHeadquarterDialog"
    >
      <el-form
        ref="chainHeadquarterFormRef"
        :model="chainHeadquarterForm"
        :rules="chainHeadquarterRules"
        label-width="120px"
      >
        <el-form-item label="连锁总部名称" prop="chainHeadquarter" required>
          <el-input
            v-model="chainHeadquarterForm.chainHeadquarter"
            placeholder="请输入连锁总部名称"
            clearable
            maxlength="100"
            @input="chainHeadquarterDuplicateError = ''"
          />
        </el-form-item>
        <!-- 后端返回重复名称时，红色提示 -->
        <div
          v-if="chainHeadquarterDuplicateError"
          class="chain-headquarter-duplicate-error"
        >
          {{ chainHeadquarterDuplicateError }}
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="chainHeadquarterDialogVisible = false">
          取 消
        </el-button>
        <el-button
          type="primary"
          :loading="chainHeadquarterLoading"
          @click="confirmAddChainHeadquarter"
        >
          确 定
        </el-button>
      </div>
    </el-dialog>

    <ShareReceiveCompanyDialog
      v-model="shareDialogVisible"
      :customerId="customerId"
      @success="$emit('submitted')"
    />
    <PushErpDialog
      v-model="syncErpDialogVisible"
      :customerId="customerId"
      @success="$emit('submitted')"
    />
  </div>
</template>

<script>
import {
  getCustomerDetail,
  getChainHeadquartersList, //获取连锁总部标识列表
  addChainHeadquarter, //新建连锁总部
  getDistrictList, //获取地区树
  getUserTypes, //获取会员类型列表
  getScopeList,
  updateOperationManagementInfo,
} from "@/api/appApi/appapi.js";
import ShareReceiveCompanyDialog from "@/components/ShareReceiveCompanyDialog/index.vue";
import PushErpDialog from "@/components/PushErpDialog/index.vue";
export default {
  name: "CustInformation",
  components: { ShareReceiveCompanyDialog, PushErpDialog },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    customerId: {
      type: [String, Number],
      default: "",
    },
    routerType: {
      type: [String, Number],
      default: 1,
    },
    unitType: {
      type: [String, Number],
      default: "",
    },
    entryMode: {
      type: String,
      default: "edit",
    },
  },
  data() {
    return {
      btnLoading: false,
      ChoiceType: null, // 选择的右侧菜单项
      dialogVisible: this.value,
      isEditing: this.entryMode === "edit",
      originalSubData: null,
      areaArr: [],
      subData: {
        enterprise: "",
        erpCode: "",
        businessStatus: "",
        province: "",
        city: "",
        district: "",
        certificateType: "",
        certificateNumber: "",
        address: "",
        unitType: "",
        pinyinCode: "",
        chainHeadquarter: "",
        legalEntity: "",
        director: "",
        isSale: [],
        customerRemark: "",
        annotation: "", // 注释（非必填）
        authorizationInfo: [],
        authorizationInfoChange: null,
        receivingAddress: [],
        auditQualificationList: [],
        scopeInfo: [],
        newAuthorizationInfo: [], //新增委托人
        unconfirmedAuthorizationInfo: [], //添加委托人弹窗
      },
      propsValue: {
        value: "id",
        label: "name",
        children: "districtList",
      }, //级联选择器配置项
      AreaList: [], //地区树
      customerCategoryOptions: [],
      chainHeadquarterOptions: [],

      // 新建连锁总部弹窗
      chainHeadquarterDialogVisible: false,
      chainHeadquarterLoading: false,
      chainHeadquarterDuplicateError: "",
      chainHeadquarterForm: {
        chainHeadquarter: "",
      },
      chainHeadquarterRules: {
        chainHeadquarter: [
          { required: true, message: "请输入连锁总部名称", trigger: "blur" },
        ],
      },

      LoadingWeituo: false, // 委托信息加载状态
      LoadingSouhe: false, // 收货信息加载状态

      addAuthorizationDialogVisible: false,
      addAuthorizationSelectedRows: [],
      replaceAuthorizationDialogVisible: false,
      replaceAuthorizationForm: {
        oldIndex: null,
        newIndex: null,
      },
      removeAuthorizationDialogVisible: false,
      removingAuthorizationIndex: -1,
      removingAuthorizationRowName: "",

      treeData: [],
      defaultProps: {
        children: "children",
        label: "type",
        disabled: "disabled",
      },

      shareDialogVisible: false,
      syncErpDialogVisible: false,

      consigneeDialogVisible: false,
      consigneeForm: {
        consigneeWarehouse: "",
        consignee: "",
        consigneeMobile: "",
        consigneeAddress: "",
      },
      consigneeRules: {
        // consigneeWarehouse: [
        //   { required: true, message: "请输入收货仓库名称", trigger: "blur" },
        // ],
        // consignee: [
        //   { required: true, message: "请输入收货人姓名", trigger: "blur" },
        // ],
        // consigneeMobile: [
        //   { required: true, message: "请输入收货人电话", trigger: "blur" },
        // ],
        consigneeAddress: [
          { required: true, message: "请输入收货地址", trigger: "blur" },
        ],
      },

      delegateDialogVisible: false,
      editingDelegateIndex: -1,
      delegateForm: {
        principalName: "",
        idNumber: "",
        isHasHeader: 1,
        businessName: "",
        delegateType: "",
        purchaseStatus: 1,
        purchaseExpiryDate: "",
        purchaseLongTerm: false,
        ephedrineStatus: 1,
        ephedrineExpiryDate: "",
        ephedrineLongTerm: false,
        bloodStatus: 1,
        bloodExpiryDate: "",
        bloodLongTerm: false,
      },
      delegateRules: {
        principalName: [
          { required: true, message: "请输入委托人姓名", trigger: "blur" },
        ],
        idNumber: [
          { required: true, message: "请输入身份证号码", trigger: "blur" },
        ],
        isHasHeader: [
          { required: true, message: "请选择是否有抬头", trigger: "change" },
        ],
        businessName: [
          { required: true, message: "请输入委托企业名称", trigger: "blur" },
        ],
        delegateType: [
          { required: true, message: "请选择委托类型", trigger: "change" },
        ],
        purchaseStatus: [
          { required: true, message: "请选择采购委托状态", trigger: "change" },
        ],
        ephedrineStatus: [
          { required: true, message: "请选择含特委托状态", trigger: "change" },
        ],
        bloodStatus: [
          { required: true, message: "请选择血液委托状态", trigger: "change" },
        ],
      },

      rules: {
        enterprise: [
          { required: true, message: "请输入企业名称", trigger: "blur" },
        ],
        province: [{ validator: this.validateArea, trigger: "change" }],
        // erpCode: [
        //   { required: true, message: "请输入单位内码", trigger: "blur" },
        // ],
        businessStatus: [
          { required: true, message: "请选择经营状态", trigger: "change" },
        ],
        certificateType: [
          { required: true, message: "请选择证件类型", trigger: "change" },
        ],
        certificateNumber: [
          { required: true, message: "请输入证件编号", trigger: "blur" },
        ],
        address: [
          { required: true, message: "请输入注册地址", trigger: "blur" },
        ],
        unitType: [
          { required: true, message: "请选择客户类别", trigger: "blur" },
        ],
        pinyinCode: [
          { required: true, message: "请输入拼音码", trigger: "blur" },
        ],
        legalEntity: [
          { required: true, message: "请输入法人", trigger: "blur" },
        ],
        director: [
          { required: true, message: "请输入负责人", trigger: "blur" },
        ],
        isSale: [
          { required: true, message: "请选择是否销售/采购", trigger: "change" },
        ],
        // customerRemark: [
        //   { required: true, message: "请输入客户备注描述", trigger: "blur" },
        // ],
      },
      viewerHostVersion: 0,
    };
  },
  computed: {
    selectedUnitTypeOption() {
      const list = Array.isArray(this.customerCategoryOptions)
        ? this.customerCategoryOptions
        : [];
      const id = this.subData ? this.subData.unitType : "";
      return list.find((it) => String(it.id) === String(id)) || null;
    },
    isChainCustomer() {
      const name =
        this.selectedUnitTypeOption && this.selectedUnitTypeOption.typeName
          ? String(this.selectedUnitTypeOption.typeName)
          : "";
      return name.includes("连锁");
    },
    currentQualification() {
      if (
        !this.subData.auditQualificationList ||
        this.subData.auditQualificationList.length === 0
      )
        return null;
      return (
        this.subData.auditQualificationList.find(
          (item) => item.id === this.ChoiceType
        ) || this.subData.auditQualificationList[0]
      );
    },
    cancelText() {
      return "取 消";
    },
    showIsChangedStyle() {
      return this.entryMode === "edit";
    },
    qualificationImgList() {
      const q = this.currentQualification;
      if (!q) return [];
      const list = Array.isArray(q.imgUrlList)
        ? q.imgUrlList.filter(Boolean)
        : [];
      if (list.length > 0) return list;
      if (q.imgUrl) return [q.imgUrl];
      return [];
    },
    viewerOptions() {
      const imgs = this.qualificationImgList;
      // 如果图片数量小于等于1，隐藏 prev 和 next 按钮
      const showNav = imgs.length > 1;
      return {
        title: false,
        navbar: false,
        inline: true,
        fullscreen: false,
        toolbar: {
          zoomIn: 1,
          zoomOut: 1,
          oneToOne: 1,
          reset: 1,
          prev: showNav ? 1 : 0,
          next: showNav ? 1 : 0,
          rotateLeft: 1,
          rotateRight: 1,
        },
      };
    },
    viewerKey() {
      const qid = this.currentQualification
        ? this.currentQualification.id
        : "none";
      return `${this.customerId}-${qid}`;
    },
    viewerHostKey() {
      const qid = this.currentQualification
        ? this.currentQualification.id
        : "none";
      return `${this.customerId}-${this.viewerHostVersion}-${qid}`;
    },
    newAuthorizationList() {
      const list =
        this.subData && Array.isArray(this.subData.newAuthorizationInfo)
          ? this.subData.newAuthorizationInfo
          : [];
      if (list.length === 0) return [];
      const first = list[0];
      if (first && typeof first === "object") return list;
      const idSet = new Set(list.map((v) => String(v)));
      const scopeList =
        this.subData && Array.isArray(this.subData.unconfirmedAuthorizationInfo)
          ? this.subData.unconfirmedAuthorizationInfo
          : [];
      return scopeList.filter((item) => {
        if (!item) return false;
        if (item.idNumber === undefined || item.idNumber === null) return false;
        return idSet.has(String(item.idNumber));
      });
    },
    replaceNewAuthorizationList() {
      const list =
        this.subData && Array.isArray(this.subData.unconfirmedAuthorizationInfo)
          ? this.subData.unconfirmedAuthorizationInfo
          : [];
      if (list.length === 0) return [];
      const existingKeys = new Set(
        (this.subData.authorizationInfo || [])
          .map((v) => this.getAuthorizationKey(v))
          .filter(Boolean)
      );
      return list.filter((row) => {
        const key = this.getAuthorizationKey(row);
        if (!key) return false;
        return !existingKeys.has(key);
      });
    },
    oldAuthorizationOptions() {
      const list =
        this.subData && Array.isArray(this.subData.authorizationInfo)
          ? this.subData.authorizationInfo
          : [];
      return list
        .map((row, index) => ({ row, index }))
        .filter(({ row }) => {
          if (!row) return false;
          const code = row.contactsCode;
          if (code === null || code === undefined) return false;
          return String(code).trim() !== "";
        });
    },
  },
  filters: {
    formatDate(date) {
      if (date == ("9999-12-31" || "2999-12-31")) return "永久";
      return date;
    },
  },
  watch: {
    async value(newVal) {
      if (newVal) {
        await this.$nextTick(() => {
          this.getItems();
        });
      }
      this.dialogVisible = newVal;
    },
    dialogVisible(newVal) {
      this.$emit("input", newVal);
    },
    // "subData.unitType"() {
    //   this.syncChainHeadquarterVisibility();
    // },
    // customerCategoryOptions() {
    //   this.syncChainHeadquarterVisibility();
    // },
  },
  methods: {
    validateArea(rule, value, callback) {
      const province = this.subData && this.subData.province;
      const city = this.subData && this.subData.city;
      const district = this.subData && this.subData.district;
      if (province && city && district) {
        callback();
        return;
      }
      callback(new Error("请选择所在地区"));
    },
    syncChainHeadquarterVisibility() {
      if (!this.subData) return;
      if (this.isChainCustomer) return;
      if (
        this.subData.chainHeadquarter !== null &&
        this.subData.chainHeadquarter !== undefined &&
        String(this.subData.chainHeadquarter).trim() !== ""
      ) {
        this.subData.chainHeadquarter = "";
      }
      this.$nextTick(() => {
        this.$refs.formone &&
          this.$refs.formone.clearValidate(["chainHeadquarter"]);
      });
    },
    // 打开新建连锁总部弹窗
    openChainHeadquarterDialog() {
      this.chainHeadquarterDialogVisible = true;
      this.chainHeadquarterDuplicateError = "";
      this.chainHeadquarterForm.chainHeadquarter = "";
      this.$nextTick(() => {
        this.$refs.chainHeadquarterFormRef &&
          this.$refs.chainHeadquarterFormRef.clearValidate();
      });
    },
    // 关闭新建连锁总部弹窗并重置
    closeChainHeadquarterDialog() {
      this.chainHeadquarterLoading = false;
      this.chainHeadquarterDuplicateError = "";
      this.chainHeadquarterForm.chainHeadquarter = "";
    },
    // 刷新连锁总部下拉列表
    async refreshChainHeadquarterOptions() {
      const res = await getChainHeadquartersList();
      if (res.code == "000000") {
        this.chainHeadquarterOptions = res.content || [];
      }
    },
    // 判断是否为连锁总部名称重复错误（预留后端约定 code / message）
    isChainHeadquarterDuplicateError(res) {
      if (!res) return false;
      const duplicateCodes = ["100100", "DUPLICATE", "CHAIN_DUPLICATE"];
      if (duplicateCodes.includes(String(res.code))) return true;
      const msg = String(res.message || "");
      return /重复|相同|已存在|不可新建/.test(msg);
    },
    // 确认新建连锁总部
    async confirmAddChainHeadquarter() {
      const valid = await this.$refs.chainHeadquarterFormRef
        .validate()
        .catch(() => false);
      if (!valid) return;

      const name = (this.chainHeadquarterForm.chainHeadquarter || "").trim();
      if (!name) return;

      this.chainHeadquarterLoading = true;
      this.chainHeadquarterDuplicateError = "";
      const res = await addChainHeadquarter({
        chainHeadquarter: name,
      });
      this.chainHeadquarterLoading = false;

      if (res.code == "000000") {
        await this.refreshChainHeadquarterOptions();
        const newId =
          (res.content && (res.content.id || res.content.chainHeadquarterId)) ||
          null;
        if (newId !== null && newId !== undefined) {
          this.subData.chainHeadquarter = Number(newId);
        } else {
          const matched = (this.chainHeadquarterOptions || []).find(
            (item) => item.chainHeadquarter === name
          );
          if (matched) {
            this.subData.chainHeadquarter = matched.id;
          }
        }
        this.$message.success("新建成功");
        this.chainHeadquarterDialogVisible = false;
        this.$nextTick(() => {
          this.$refs.formone &&
            this.$refs.formone.validateField("chainHeadquarter");
        });
        return;
      } else if (res.code == "601001") {
        this.chainHeadquarterDuplicateError =
          res.message || `注意：已有相同的连锁总部名称（${name}），不可新建`;
        return;
      }
    },
    onAreaChange(val) {
      const next = Array.isArray(val) ? val : [];
      const province = next[0] !== undefined ? next[0] : "";
      const city = next[1] !== undefined ? next[1] : "";
      const district = next[2] !== undefined ? next[2] : "";
      this.subData.province = province;
      this.subData.city = city;
      this.subData.district = district;
      this.$nextTick(() => {
        this.$refs.formone && this.$refs.formone.validateField("province");
      });
    },
    syncAreaArrFromSubData() {
      const province = this.subData && this.subData.province;
      const city = this.subData && this.subData.city;
      const district = this.subData && this.subData.district;
      if (province && city && district) {
        if (province !== "" && province !== null && province !== undefined) {
          const n = Number(province);
          if (!isNaN(n)) this.subData.province = n;
        }
        if (city !== "" && city !== null && city !== undefined) {
          const n = Number(city);
          if (!isNaN(n)) this.subData.city = n;
        }
        if (district !== "" && district !== null && district !== undefined) {
          const n = Number(district);
          if (!isNaN(n)) this.subData.district = n;
        }
        this.areaArr = [Number(province), Number(city), Number(district)];
        return;
      }
      this.areaArr = [];
    },
    // 关闭抽屉
    handleClose() {
      this.resetForm();
      this.$emit("input", false);
      this.$emit("closed");
    },
    // 取消按钮
    handleCancel() {
      if (this.entryMode === "view" && this.isEditing) {
        this.cancelEdit();
        return;
      }
      this.handleClose();
    },
    enterEditMode() {
      this.isEditing = true;
      this.applyTreeDisabled();
    },
    cancelEdit() {
      if (!this.originalSubData) {
        this.isEditing = false;
        return;
      }
      this.subData = JSON.parse(JSON.stringify(this.originalSubData));
      this.isEditing = false;
      this.syncAreaArrFromSubData();
      this.$nextTick(() => {
        if (this.$refs.tree && this.subData.scopeInfo) {
          this.$refs.tree.setCheckedKeys(
            this.subData.scopeInfo.map((item) => item.businessScopeId)
          );
        }
      });
      this.applyTreeDisabled();
    },
    applyTreeDisabled() {
      if (!this.treeData || this.treeData.length === 0) return;
      this.setTreeDisabled(this.treeData, !this.isEditing);
    },
    setTreeDisabled(nodes, disabled) {
      nodes.forEach((node) => {
        this.$set(node, "disabled", disabled);
        if (node.children && node.children.length > 0) {
          this.setTreeDisabled(node.children, disabled);
        }
      });
    },
    // 判断经营范围节点是否含有子级
    hasScopeChildren(data) {
      return !!(data && data.children && data.children.length > 0);
    },
    // 从树节点向上收集所有父级 businessScopeId
    collectAncestorScopeIds(nodeKey) {
      const tree = this.$refs.tree;
      if (!tree || nodeKey === undefined || nodeKey === null) return [];
      const ancestorIds = [];
      let treeNode = tree.getNode(nodeKey);
      while (treeNode && treeNode.parent) {
        const parentData = treeNode.parent.data;
        if (
          parentData &&
          parentData.businessScopeId !== undefined &&
          parentData.businessScopeId !== null
        ) {
          ancestorIds.push(parentData.businessScopeId);
        }
        treeNode = treeNode.parent;
      }
      return ancestorIds;
    },
    // 勾选子级时自动勾选其所有父级
    handleScopeCheck(data, checked) {
      if (!this.isEditing) return;
      const tree = this.$refs.tree;
      if (!tree || !data) return;
      const checkedKeys = checked.checkedKeys || [];
      const nodeKey = data.businessScopeId;
      const isChecked = checkedKeys.some(
        (key) => String(key) === String(nodeKey)
      );
      if (!isChecked) return;
      const ancestorIds = this.collectAncestorScopeIds(nodeKey);
      if (!ancestorIds.length) return;
      const mergedKeys = Array.from(new Set([...checkedKeys, ...ancestorIds]));
      tree.setCheckedKeys(mergedKeys);
    },
    // 一键勾选/取消当前节点下所有子级（不含自身，再次点击则取消）
    handleCheckAllChildren(data) {
      if (!this.isEditing) return;
      const tree = this.$refs.tree;
      if (!tree || !data) return;
      const childIds = this.collectDescendantScopeIds(data);
      if (!childIds.length) return;
      const currentChecked = tree.getCheckedKeys();
      const childIdSet = new Set(childIds.map((id) => String(id)));
      // 子级已全部勾选时，再次点击则取消子级选中
      const allChildrenChecked = childIds.every((id) =>
        currentChecked.map((key) => String(key)).includes(String(id))
      );
      if (allChildrenChecked) {
        const nextKeys = currentChecked.filter(
          (id) => !childIdSet.has(String(id))
        );
        tree.setCheckedKeys(nextKeys);
        return;
      }
      // 勾选子级时同步勾选当前节点及其所有父级
      const ancestorIds = this.collectAncestorScopeIds(data.businessScopeId);
      const parentKeys = [data.businessScopeId, ...ancestorIds];
      const mergedKeys = Array.from(
        new Set([...currentChecked, ...childIds, ...parentKeys])
      );
      tree.setCheckedKeys(mergedKeys);
    },
    // 递归收集节点下所有子级的 businessScopeId
    collectDescendantScopeIds(node) {
      const ids = [];
      const walk = (items) => {
        (items || []).forEach((item) => {
          if (
            item.businessScopeId !== undefined &&
            item.businessScopeId !== null
          ) {
            ids.push(item.businessScopeId);
          }
          if (item.children && item.children.length > 0) {
            walk(item.children);
          }
        });
      };
      walk(node.children);
      return ids;
    },
    // 处理树节点长期选中
    handleLongTermChange(val, data) {
      if (val) {
        this.$set(data, "scopeEffectiveEndTime", "9999-12-31");
      } else {
        this.$set(data, "scopeEffectiveEndTime", "");
      }
    },
    // 递归处理树数据回显
    traverseTree(nodes, scopeMap) {
      nodes.forEach((node) => {
        const mappedData = scopeMap[node.businessScopeId];
        if (mappedData) {
          this.$set(
            node,
            "scopeEffectiveEndTime",
            mappedData.scopeEffectiveEndTime
          );
          this.$set(
            node,
            "isLongTerm",
            mappedData.scopeEffectiveEndTime === "9999-12-31"
          );
        } else {
          this.$set(node, "scopeEffectiveEndTime", "");
          this.$set(node, "isLongTerm", false);
        }
        if (node.children && node.children.length > 0) {
          this.traverseTree(node.children, scopeMap);
        }
      });
    },
    normalizeQualificationItemVal(item) {
      const raw = item.templateParamValue;

      if (raw === undefined || raw === null) return;

      let nextVal = raw;
      if (item.templateParamType == 1) {
        if (typeof raw === "string") {
          nextVal = raw.length >= 10 ? raw.slice(0, 10) : raw;
        } else if (typeof raw === "number") {
          const ts = raw > 1e12 ? raw : raw * 1000;
          const d = new Date(ts);
          if (!isNaN(d.getTime())) {
            const yyyy = d.getFullYear();
            const mm = String(d.getMonth() + 1).padStart(2, "0");
            const dd = String(d.getDate()).padStart(2, "0");
            nextVal = `${yyyy}-${mm}-${dd}`;
          }
        }
      }
      this.$set(item, "templateParamValue", nextVal);
    },
    normalizeQualificationList() {
      const list = this.subData.auditQualificationList || [];
      list.forEach((q) => {
        const items = q.auditQualificationItemList || [];
        items.forEach((it) => this.normalizeQualificationItemVal(it));
      });
    },
    /** 获取数据 */
    async getItems() {
      if (!this.customerId) return;
      this.isEditing = this.entryMode === "edit";
      this.viewerHostVersion += 1;
      this.ChoiceType = null;
      if (this.subData && Array.isArray(this.subData.auditQualificationList)) {
        this.subData.auditQualificationList = [];
      }
      // 获取详情
      let res = await getCustomerDetail({
        customerId: this.customerId,
        type: this.routerType,
      });
      if (res.code == "000000") {
        this.subData = res.content;
        for (let key in this.subData) {
          this.subData[key] = this.subData[key] || "";
        }
        this.subData.erpCode = this.subData.erpCode || "-";
        this.subData.chainHeadquarter =
          Number(this.subData.chainHeadquarter) || "";
        this.subData.unitType = Number(this.subData.unitType) || "";
        this.originalSubData = JSON.parse(JSON.stringify(res.content));
        if (Array.isArray(this.subData.isSale)) {
          this.subData.isSale = this.subData.isSale.map((v) => Number(v));
        }
        this.syncAreaArrFromSubData();
        this.normalizeQualificationList();

        // 设置右侧资质列表初始选中
        if (
          this.subData.auditQualificationList &&
          this.subData.auditQualificationList.length > 0
        ) {
          this.ChoiceType = this.subData.auditQualificationList[0].id;
        } else {
          this.ChoiceType = null;
        }
      }
      //获取经营范围
      let scopeList = await getChainHeadquartersList();
      if (scopeList.code == "000000") {
        this.chainHeadquarterOptions = scopeList.content;
      }
      //获取地区树
      let AdreList = await getDistrictList();
      if (AdreList.code == "000000") {
        this.AreaList = await this.getTreeData(
          AdreList.content,
          "districtList"
        );
      }
      //获取会员类型列表
      let TypesList = await getUserTypes();
      if (TypesList.code == "000000") {
        this.customerCategoryOptions = TypesList.content;
      }
      this.syncChainHeadquarterVisibility();
      // 获取平台经营范围树
      let scopeRes = await getScopeList();
      if (scopeRes.code == "000000") {
        this.treeData = scopeRes.content;

        // 映射接口返回的scopeInfo回显日期
        if (this.subData.scopeInfo && this.subData.scopeInfo.length > 0) {
          const scopeMap = {};
          this.subData.scopeInfo.forEach((item) => {
            scopeMap[item.businessScopeId] = item;
          });
          this.traverseTree(this.treeData, scopeMap);
        }
        this.applyTreeDisabled();
        if (this.subData.scopeInfo && this.subData.scopeInfo.length > 0) {
          this.$nextTick(() => {
            this.$refs.tree &&
              this.$refs.tree.setCheckedKeys(
                this.subData.scopeInfo.map((item) => item.businessScopeId)
              );
          });
        }
      }
    },
    // 提交按钮
    async handleSubmit() {
      try {
        if (!this.isEditing) return;
        const validOne = await this.$refs.formone.validate().catch(() => false);
        if (!validOne) {
          this.$message.error("基本信息表单验证失败");
          return;
        }
        // 获取勾选的经营范围
        const checkedNodes = this.$refs.tree.getCheckedNodes();
        this.subData.scopeInfo = checkedNodes.map((node) => ({
          businessScopeId: node.businessScopeId,
          businessScopeName: node.type,
          scopeEffectiveEndTime: node.scopeEffectiveEndTime || "",
        }));

        const payload = {
          ...this.subData,
          customerId: this.customerId,
          commitType: this.entryMode === "edit" ? 2 : 1, //1.编辑客户 2.完善经营范围（待更新状态）
        };
        if (
          !payload.authorizationInfoChange ||
          !payload.authorizationInfoChange.oldEntrustInfoId ||
          !payload.authorizationInfoChange.newEntrustInfoId
        ) {
          delete payload.authorizationInfoChange;
        }
        this.btnLoading = true;
        let res = await updateOperationManagementInfo(payload);
        this.btnLoading = false;
        if (res.code == "000000") {
          this.$message.success("经营管理更新成功");
          this.handleClose();
          this.$emit("submitted");
          // if (this.entryMode === "view") {
          //   this.openShareDialog();
          // }
        }
      } catch (error) {
        console.error("提交失败:", error);
        this.$message.error("提交失败，请稍后重试");
      }
    },

    openConsigneeDialog() {
      this.consigneeDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.consigneeFormRef &&
          this.$refs.consigneeFormRef.clearValidate();
      });
    },
    closeConsigneeDialog() {
      this.consigneeDialogVisible = false;
      Object.assign(this.consigneeForm, this.$options.data().consigneeForm);
    },
    async confirmConsignee() {
      const valid = await this.$refs.consigneeFormRef
        .validate()
        .catch(() => false);
      if (!valid) return;
      const now = new Date();
      const yyyy = now.getFullYear();
      const mm = String(now.getMonth() + 1).padStart(2, "0");
      const dd = String(now.getDate()).padStart(2, "0");
      const hh = String(now.getHours()).padStart(2, "0");
      const mi = String(now.getMinutes()).padStart(2, "0");
      const ss = String(now.getSeconds()).padStart(2, "0");
      this.subData.receivingAddress.push({
        ...this.consigneeForm,
        createTime: `${yyyy}-${mm}-${dd} ${hh}:${mi}:${ss}`,
      });
      this.closeConsigneeDialog();
    },
    removeConsignee(index) {
      this.subData.receivingAddress.splice(index, 1);
    },
    auditReject() {
      this.$emit("auditReject", {
        customerId: this.customerId,
        data: this.subData,
      });
    },
    auditApprove() {
      this.$emit("auditApprove", {
        customerId: this.customerId,
        data: this.subData,
      });
    },

    openShareDialog() {
      this.shareDialogVisible = true;
    },
    openSyncErpDialog() {
      this.syncErpDialogVisible = true;
    },
    openDelegateDialog(row, index) {
      this.editingDelegateIndex = index;
      this.delegateForm = {
        idNumber: row.idNumber || "",
        isHasHeader: row.isHasHeader || 2,
        businessName: row.businessName || "",
        principalName: row.principalName || "",
        delegateType: row.delegateType || "",
        purchaseStatus: row.purchaseStatus || 2,
        purchaseExpiryDate: row.purchaseExpiryDate || "",
        purchaseLongTerm: row.purchaseExpiryDate === "9999-12-31",
        ephedrineStatus: row.ephedrineStatus || 2,
        ephedrineExpiryDate: row.ephedrineExpiryDate || "",
        ephedrineLongTerm: row.ephedrineExpiryDate === "9999-12-31",
        bloodStatus: row.bloodStatus || 2,
        bloodExpiryDate: row.bloodExpiryDate || "",
        bloodLongTerm: row.bloodExpiryDate === "9999-12-31",
      };
      this.delegateDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.delegateFormRef &&
          this.$refs.delegateFormRef.clearValidate();
      });
    },
    closeDelegateDialog() {
      this.delegateDialogVisible = false;
      this.editingDelegateIndex = -1;
      Object.assign(this.delegateForm, this.$options.data().delegateForm);
    },
    onDelegateLongTermChange(type) {
      if (type === "purchase") {
        if (this.delegateForm.purchaseLongTerm) {
          this.delegateForm.purchaseExpiryDate = "9999-12-31";
        } else if (this.delegateForm.purchaseExpiryDate === "9999-12-31") {
          this.delegateForm.purchaseExpiryDate = "";
        }
      }
      if (type === "ephedrine") {
        if (this.delegateForm.ephedrineLongTerm) {
          this.delegateForm.ephedrineExpiryDate = "9999-12-31";
        } else if (this.delegateForm.ephedrineExpiryDate === "9999-12-31") {
          this.delegateForm.ephedrineExpiryDate = "";
        }
      }
      if (type === "blood") {
        if (this.delegateForm.bloodLongTerm) {
          this.delegateForm.bloodExpiryDate = "9999-12-31";
        } else if (this.delegateForm.bloodExpiryDate === "9999-12-31") {
          this.delegateForm.bloodExpiryDate = "";
        }
      }
    },
    onDelegateStatusChange(type) {
      if (type === "header" && this.delegateForm.isHasHeader != 1) {
        this.delegateForm.businessName = "";
      }
      if (type === "purchase" && this.delegateForm.purchaseStatus != 1) {
        this.delegateForm.purchaseLongTerm = false;
        this.delegateForm.purchaseExpiryDate = "";
      }
      if (type === "ephedrine" && this.delegateForm.ephedrineStatus != 1) {
        this.delegateForm.ephedrineLongTerm = false;
        this.delegateForm.ephedrineExpiryDate = "";
      }
      if (type === "blood" && this.delegateForm.bloodStatus != 1) {
        this.delegateForm.bloodLongTerm = false;
        this.delegateForm.bloodExpiryDate = "";
      }
    },
    async confirmDelegate() {
      const valid = await this.$refs.delegateFormRef
        .validate()
        .catch(() => false);
      if (!valid) return;
      if (this.editingDelegateIndex < 0) return;

      const updated = {
        ...this.subData.authorizationInfo[this.editingDelegateIndex],
        principalName: this.delegateForm.principalName,
        idNumber: this.delegateForm.idNumber,
        isHasHeader: this.delegateForm.isHasHeader,
        businessName: this.delegateForm.businessName,
        delegateType: this.delegateForm.delegateType,
        purchaseStatus: this.delegateForm.purchaseStatus,
        purchaseExpiryDate:
          this.delegateForm.purchaseStatus == 1
            ? this.delegateForm.purchaseExpiryDate
            : "",
        ephedrineStatus: this.delegateForm.ephedrineStatus,
        ephedrineExpiryDate:
          this.delegateForm.ephedrineStatus == 1
            ? this.delegateForm.ephedrineExpiryDate
            : "",
        bloodStatus: this.delegateForm.bloodStatus,
        bloodExpiryDate:
          this.delegateForm.bloodStatus == 1
            ? this.delegateForm.bloodExpiryDate
            : "",
      };
      this.$set(
        this.subData.authorizationInfo,
        this.editingDelegateIndex,
        updated
      );
      this.closeDelegateDialog();
    },
    isAuthorizationNew(row) {
      if (!row) return false;
      const list =
        this.subData && Array.isArray(this.subData.newAuthorizationInfo)
          ? this.subData.newAuthorizationInfo
          : [];
      if (list.length === 0) return false;
      const idNumber = row.idNumber;
      return list.some((it) => {
        if (it === null || it === undefined) return false;
        if (typeof it === "string" || typeof it === "number") {
          return idNumber !== undefined && String(it) === String(idNumber);
        }
        if (typeof it === "object") {
          if (it.idNumber !== undefined) {
            return (
              idNumber !== undefined && String(it.idNumber) === String(idNumber)
            );
          }
          if (it.principalName && row.principalName) {
            return String(it.principalName) === String(row.principalName);
          }
        }
        return false;
      });
    },
    getAuthorizationKey(row) {
      if (!row) return "";
      if (row.entrustEnterpriseId) return `id:${row.entrustEnterpriseId}`;
      return `name:${row.principalName || ""}-type:${row.delegateType || ""}`;
    },
    getAuthorizationInfoId(row) {
      if (!row) return "";
      if (
        row.authorizationInfoId !== undefined &&
        row.authorizationInfoId !== null
      )
        return String(row.authorizationInfoId);
      // if (row.entrustInfoId !== undefined && row.entrustInfoId !== null)
      //   return String(row.entrustInfoId);
      // if (row.id !== undefined && row.id !== null) return String(row.id);
      // if (row.principalId !== undefined && row.principalId !== null)
      //   return String(row.principalId);
      // if (row.idNumber !== undefined && row.idNumber !== null)
      //   return String(row.idNumber);
      return "";
    },
    formatAuthorizationOption(item) {
      const name = item && item.principalName ? item.principalName : "";
      const id = item && item.idNumber ? item.idNumber : "";
      if (name && id) return `${name}（${id}）`;
      return name || id || "";
    },
    addAuthorizationInfo() {
      this.addAuthorizationDialogVisible = true;
      this.addAuthorizationSelectedRows = [];
      this.$nextTick(() => {
        const table = this.$refs.addAuthorizationTable;
        if (!table) return;
        table.clearSelection();
        const existingKeys = new Set(
          (this.subData.authorizationInfo || [])
            .map((v) => this.getAuthorizationKey(v))
            .filter(Boolean)
        );
        const list = Array.isArray(this.subData.unconfirmedAuthorizationInfo)
          ? this.subData.unconfirmedAuthorizationInfo
          : [];
        list.forEach((row) => {
          const key = this.getAuthorizationKey(row);
          if (!key) return;
          if (!existingKeys.has(key)) return;
          table.toggleRowSelection(row, true);
        });
      });
    },
    onAddAuthorizationSelectionChange(rows) {
      this.addAuthorizationSelectedRows = rows || [];
    },
    closeAddAuthorizationDialog() {
      this.addAuthorizationDialogVisible = false;
      this.addAuthorizationSelectedRows = [];
    },
    confirmAddAuthorizationDialog() {
      const selected = this.addAuthorizationSelectedRows || [];
      if (selected.length === 0) {
        this.$message.warning("请选择要添加的委托人");
        return;
      }
      const existingKeys = new Set(
        (this.subData.authorizationInfo || []).map((v) =>
          this.getAuthorizationKey(v)
        )
      );
      selected.forEach((row) => {
        const key = this.getAuthorizationKey(row);
        if (!key || existingKeys.has(key)) return;
        this.subData.authorizationInfo.push(JSON.parse(JSON.stringify(row)));
        existingKeys.add(key);
      });
      this.closeAddAuthorizationDialog();
    },
    replaceAuthorizationInfo() {
      this.replaceAuthorizationDialogVisible = true;
      this.replaceAuthorizationForm = { oldIndex: null, newIndex: null };
    },
    closeReplaceAuthorizationDialog() {
      this.replaceAuthorizationDialogVisible = false;
      this.replaceAuthorizationForm = { oldIndex: null, newIndex: null };
    },
    confirmReplaceAuthorizationDialog() {
      const oldIndex = this.replaceAuthorizationForm.oldIndex;
      const newIndex = this.replaceAuthorizationForm.newIndex;
      if (oldIndex === null || oldIndex === undefined) {
        this.$message.warning("请选择原委托人");
        return;
      }
      if (newIndex === null || newIndex === undefined) {
        this.$message.warning("请选择新委托人");
        return;
      }
      const nextRow = this.replaceNewAuthorizationList[newIndex];
      if (!nextRow) {
        this.$message.warning("新委托人数据不存在");
        return;
      }
      const oldRow = this.subData.authorizationInfo
        ? this.subData.authorizationInfo[oldIndex]
        : null;
      const oldEntrustInfoId = this.getAuthorizationInfoId(oldRow);
      const newEntrustInfoId = this.getAuthorizationInfoId(nextRow);
      if (oldEntrustInfoId && newEntrustInfoId) {
        this.$set(this.subData, "authorizationInfoChange", {
          oldEntrustInfoId,
          newEntrustInfoId,
        });
      }
      this.$set(
        this.subData.authorizationInfo,
        oldIndex,
        JSON.parse(JSON.stringify(nextRow))
      );
      this.closeReplaceAuthorizationDialog();
    },
    removeAuthorizationInfo(row, index) {
      this.removingAuthorizationIndex = index;
      this.removingAuthorizationRowName =
        (row && row.principalName) || (row && row.name) || "";
      this.removeAuthorizationDialogVisible = true;
    },
    closeRemoveAuthorizationDialog() {
      this.removeAuthorizationDialogVisible = false;
      this.removingAuthorizationIndex = -1;
      this.removingAuthorizationRowName = "";
    },
    confirmRemoveAuthorizationDialog() {
      if (
        this.removingAuthorizationIndex !== null &&
        this.removingAuthorizationIndex !== undefined &&
        this.removingAuthorizationIndex >= 0
      ) {
        this.subData.authorizationInfo.splice(
          this.removingAuthorizationIndex,
          1
        );
      }
      this.closeRemoveAuthorizationDialog();
    },

    // 重置表单
    resetForm() {
      this.$refs.formone && this.$refs.formone.resetFields();
      Object.assign(this.subData, this.$options.data().subData);
      this.areaArr = [];
      this.ChoiceType = null;
      this.isEditing = true;
      this.originalSubData = null;
      this.consigneeDialogVisible = false;
      this.delegateDialogVisible = false;
      this.addAuthorizationDialogVisible = false;
      this.replaceAuthorizationDialogVisible = false;
      this.removeAuthorizationDialogVisible = false;
      this.shareDialogVisible = false;
      this.syncErpDialogVisible = false;
    },

    // 设置表单数据（供父组件调用）
    setFormData(data) {
      this.subData = {
        ...this.subData,
        ...data,
      };
      this.syncAreaArrFromSubData();
    },
  },
};
</script>

<style lang="scss" scoped>
.card-container {
  display: flex;
  height: 100vh;
  position: relative;
  padding-bottom: 63px !important;
  font-size: 13px;
  .card-left {
    flex: 7;
    padding-bottom: 30px !important;
    .titler {
      font-size: 17px;
      font-weight: bold;
      margin-bottom: 10px;
      color: #000;
    }
    padding: 20px;
    overflow-y: auto;
    // 专门针对占满整行的表单项
    .full-width-item {
      width: 100% !important;
      /deep/ .el-form-item__content {
        width: 80%;
        .el-textarea,
        .el-input {
          width: 100% !important;
          .el-textarea__inner {
            width: 100%;
          }
        }
      }
    }
  }

  .card-right {
    flex: 6;
    display: flex;
    overflow-y: auto;
    .Onseter {
      width: 200px;
      flex-shrink: 0;
      background: #e5e7eb;
      line-height: 30px;
      text-align: right;
      .OnsetActive {
        background: #fff;
        font-weight: bold;
        color: rgb(100, 108, 255);
      }
      .NonActive {
        cursor: pointer;
      }
      .NonActive:hover {
        color: rgb(100, 108, 255);
      }
      .onset-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 10px;
      }
      .onset-text {
        flex: 1;
        text-align: right;
        font-size: 13px;
        min-height: 30px;
      }
      .onset-badges {
        display: flex;
        align-items: center;
        gap: 6px;
        margin-left: 8px;
      }
      .onset-badge {
        height: 16px;
        line-height: 16px;
        padding: 0 8px;
        font-size: 11px;
        border-radius: 10px;
        color: #fff;
        flex-shrink: 0;
      }
      .onset-badge-update {
        background: #f56c6c;
      }
      .onset-badge-expired {
        background: #909399;
      }
    }
    .rigtContainer {
      flex: 1;
      min-width: 400px;
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      .righTop {
        flex: 0 0 auto;
        overflow-y: visible;
        overflow-x: visible;
        box-sizing: border-box;
      }
      .righBottom {
        flex: 1;
        overflow-y: auto;
      }
    }
  }

  .dialog-footer {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 15px 20px;
    background: #fff;
    border-top: 1px solid #e8eaec;
    text-align: right;
    z-index: 1;
  }

  /* 经营范围树节点布局 */
  .custom-tree-node {
    display: flex;
    align-items: center;
    width: 100%;
    // margin-left: -10px;
    padding-right: 20px;
    font-size: 13px;
  }
  .scope-check-children-btn {
    flex-shrink: 0;
    margin-right: 8px;
    font-size: 12px;
    white-space: nowrap;
  }
  .scope-tree-label {
    flex: 1;
    min-width: 0;
  }

  /* 连锁总部：下拉与添加按钮同行 */
  .chain-headquarter-field {
    display: flex;
    align-items: center;
    width: 100%;
  }
  .chain-headquarter-select {
    flex: 1;
    min-width: 0;
  }
  .chain-headquarter-add-btn {
    flex-shrink: 0;
    margin-left: 8px;
    padding: 0 4px;
    font-size: 13px;
  }
}

/* 新建连锁总部：重复名称红色提示 */
.chain-headquarter-duplicate-error {
  margin: -6px 0 0 120px;
  color: #f56c6c;
  font-size: 13px;
  line-height: 20px;
}

/* 响应式调整 */
@media screen and (max-width: 768px) {
  /deep/ .el-drawer.rtl {
    width: 90% !important;
  }
}
/deep/ .viewer-canvas {
  background: #fff;
}

/deep/ .changed-field .el-form-item__label {
  color: #f56c6c;
}
/deep/ .changed-input .el-input__inner,
/deep/ .changed-input .el-textarea__inner,
/deep/ .changed-input.el-date-editor .el-input__inner {
  border-color: #f56c6c;
}

.field-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
}
/deep/ .field-wrapper > .el-input,
/deep/ .field-wrapper > .el-select,
/deep/ .field-wrapper > .el-date-editor {
  flex: 1;
}
.changed-text {
  border: 1px solid #f56c6c;
  background-color: #f5f7fa;
  color: #c0c4cc;
  border-radius: 4px;
  width: 100%;
  padding: 0px 10px;
}
.Ontext {
  border-radius: 4px;
  background-color: #f5f7fa;
  border: 1px solid #e4e7ed;
  color: #c0c4cc;
  width: 100%;
  padding: 0px 10px;
}
.update-badge {
  position: absolute;
  top: -10px;
  right: -15px;
  flex-shrink: 0;
  height: 16px;
  width: 40px;
  line-height: 16px;
  text-align: center;
  padding: 0 8px;
  font-size: 11px;
  color: #fff;
  background: #f56c6c;
  border-radius: 10px;
}

.delegate-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  padding: 0 8px;
  border-radius: 2px;
  font-size: 12px;
  border: 1px solid #dcdfe6;
  color: #606266;
  background: #f5f7fa;
}
.delegate-tag-new {
  border-color: #e6a23c;
  background: #fdf6ec;
  color: #e6a23c;
}

.delegation-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 10px;
}
.section-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.section-title .title {
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 10px;
}
.section-title .title i {
  color: #909399;
}
.section-title .badge {
  background: rgb(100, 108, 255);
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  padding: 0 12px;
  border-radius: 12px;
  line-height: 22px;
}
.section-title .actions {
  display: flex;
  gap: 10px;
}
.btn-sm {
  padding: 4px 16px;
  font-size: 12px;
  border-radius: 4px;
  font-weight: 500;
}
.btn-add {
  background: rgb(100, 108, 255);
  border-color: rgb(100, 108, 255);
  color: #fff;
}
.btn-add:hover,
.btn-add:focus {
  background: rgba(100, 108, 255, 0.9);
  border-color: rgba(100, 108, 255, 0.9);
  color: #fff;
}
.btn-replace {
  background: #fff;
  color: rgb(100, 108, 255);
  border: 1px solid rgb(100, 108, 255);
}
.btn-replace:hover,
.btn-replace:focus {
  background: rgba(100, 108, 255, 0.08);
  border-color: rgb(100, 108, 255);
  color: rgb(100, 108, 255);
}
.delegation-list {
  // max-height: 250px;
  // overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-right: 6px;
}
.new-delegation-list {
  max-height: unset;
  padding-right: 0;
}
.card-item {
  background: #ffffff;
  border: 1px solid #eef2f8;
  border-radius: 12px;
  padding: 14px 20px 12px 20px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.02);
  transition: all 0.2s;
}
.card-item:hover {
  border-color: #cdd8e6;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
}
.card-item.card-new {
  border-color: #90caf9;
  background: #f5faff;
  border-width: 2px;
  padding: 10px 16px 8px 16px;
}
.card-item.card-new:hover {
  border-color: #42a5f5;
}
.card-item.card-new .card-top-row {
  border-bottom-color: #bbdefb;
  margin-bottom: 4px;
  padding-bottom: 5px;
}
.card-item.card-new .info-row-strong {
  padding: 4px 12px;
  margin-bottom: 8px;
  font-size: 13px;
  background: #f0f6ff;
  border-color: #bbdefb;
}
.card-item.card-new .status-row {
  margin-bottom: 0;
  gap: 8px;
}
.card-item.card-new .status-block {
  padding: 4px 10px 5px 10px;
  min-width: 80px;
  background: #f0f6ff;
  border-color: #bbdefb;
}
.card-item.card-new .status-title {
  font-size: 10px;
}
.card-item.card-new .status-tag {
  font-size: 11px;
  line-height: 20px;
  padding: 0 10px;
}
.card-item.card-new .card-name {
  font-size: 14px;
}
.card-item.card-new .tag-badge {
  font-size: 11px;
  line-height: 20px;
  padding: 0 10px;
}
.card-item.card-new .weak-item {
  font-size: 11px;
}
.card-item.card-new .header-tag {
  font-size: 9px;
  line-height: 16px;
  padding: 0 6px;
}
.card-top-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px 18px;
  flex-wrap: wrap;
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px dashed #eef2f8;
}
.card-top-left {
  display: flex;
  align-items: center;
  gap: 10px 18px;
  flex-wrap: wrap;
}
.card-top-right {
  display: flex;
  align-items: center;
  gap: 8px 16px;
  flex-wrap: wrap;
  font-size: 12px;
  color: #b0bcca;
}
.tag-badge {
  display: inline-block;
  padding: 0 14px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  line-height: 24px;
}
.tag-badge.tag-update {
  background: #fff3e0;
  color: #e67e22;
}
.tag-badge.tag-new {
  background: #e3f2fd;
  color: #1565c0;
}
.tag-badge.hidden {
  display: none;
}
.card-name {
  font-size: 16px;
  font-weight: 600;
  color: #0b1e3c;
}
.id-inline {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #909399;
}
.id-inline .value {
  color: rgb(100, 108, 255);
  font-weight: 600;
}
.weak-item {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #b0bcca;
}
.weak-item .label {
  color: #c8d0d8;
  font-weight: 400;
}
.weak-item .value {
  color: #b0bcca;
  font-weight: 400;
}
.header-tag {
  display: inline-block;
  padding: 0 8px;
  border-radius: 8px;
  font-size: 10px;
  font-weight: 500;
  line-height: 18px;
  opacity: 0.7;
}
.header-tag.has {
  background: #e6f7e6;
  color: #1d8a3e;
}
.header-tag.none {
  background: #f5f6f8;
  color: #a0aab8;
}
.info-row-strong {
  display: flex;
  align-items: center;
  gap: 12px 32px;
  flex-wrap: wrap;
  padding: 6px 14px;
  background: #f8faff;
  border-radius: 8px;
  border: 1px solid #eef2f8;
  margin-bottom: 12px;
  font-size: 14px;
}
.info-row-strong .label {
  color: #8c9aa8;
  font-weight: 400;
}
.info-row-strong .value {
  font-weight: 500;
  color: #1a2332;
}
.status-row {
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}
.status-block {
  flex: 1;
  min-width: 110px;
  background: #f8faff;
  border-radius: 8px;
  padding: 6px 14px 8px 14px;
  border: 1px solid #eef2f8;
}
.status-title {
  font-size: 11px;
  color: #8c9aa8;
  font-weight: 600;
  margin-bottom: 3px;
  letter-spacing: 0.3px;
}
.status-content {
  display: flex;
  align-items: center;
  gap: 6px 10px;
  flex-wrap: wrap;
}
.status-tag {
  display: inline-block;
  padding: 0 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  line-height: 22px;
  white-space: nowrap;
}
.status-tag.enabled {
  background: #e6f7e6;
  color: #1d8a3e;
}
.status-tag.disabled {
  background: #fde8e8;
  color: #c72a2a;
}
.status-tag.permanent {
  background: #e8edf5;
  color: #3a5a7a;
}
.status-tag.date {
  background: #f0f4fe;
  color: rgb(100, 108, 255);
}
.status-tag.empty {
  background: #f5f6f8;
  color: #a0aab8;
}
.card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #f0f2f6;
  padding-top: 10px;
  margin-top: 2px;
  gap: 10px;
  flex-wrap: wrap;
}
.footer-id-contact {
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 13px;
  color: #4a5a6e;
  flex-wrap: wrap;
}
.footer-id-contact .id-block {
  display: flex;
  align-items: center;
  gap: 4px;
}
.footer-id-contact .id-block .label {
  color: #8c9aa8;
}
.footer-id-contact .id-block .value {
  font-weight: 600;
  color: #1a2332;
}
.footer-id-contact .id-block .value {
  color: rgb(100, 108, 255);
}
.card-actions {
  display: flex;
  gap: 12px;
}
.action-btn {
  border: none;
  background: transparent;
  color: rgb(100, 108, 255);
  cursor: pointer;
  font-size: 13px;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.15s;
  font-weight: 500;
}
.action-btn:hover {
  background: rgba(100, 108, 255, 0.08);
}
.action-btn.danger {
  color: #d9534f;
}
.action-btn.danger:hover {
  background: #fde8e8;
}
.delegation-empty {
  border: 1px dashed #e8ecf1;
  border-radius: 12px;
  padding: 20px;
  text-align: center;
  color: #909399;
  background: #fff;
}

.new-authorization-panel {
  margin-top: 12px;
  padding: 0;
  background: transparent;
}
.new-authorization-tip {
  color: #606266;
  margin-bottom: 10px;
  font-size: 12px;
}
.new-section-divider {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #8c9aa8;
  font-size: 12px;
  margin: 5px 0 7px 0;
}
.new-section-divider::after {
  content: "";
  flex: 1;
  height: 1px;
  background: #e8ecf1;
}
.alert-banner-simple {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #fff8e1;
  border: 1px solid #ffe082;
  border-radius: 8px;
  padding: 8px 16px;
  margin-top: 2px;
  margin-bottom: 12px;
}
.alert-banner-simple .alert-icon {
  font-size: 16px;
  flex-shrink: 0;
  color: #e6a23c;
}
.alert-banner-simple .alert-text {
  font-size: 13px;
  color: #7a5c00;
}
.alert-banner-simple .alert-text strong {
  font-weight: 600;
}

.replace-authorization-form {
  padding: 10px 0 0;
}
.replace-authorization-row {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.replace-authorization-label {
  width: 90px;
  color: #606266;
}
.replace-authorization-tip {
  color: #909399;
  font-size: 12px;
  line-height: 18px;
  margin-left: 90px;
}

.remove-authorization-body {
  display: flex;
  gap: 14px;
  padding: 10px 0;
}
.remove-authorization-icon {
  font-size: 26px;
  color: #e6a23c;
  margin-top: 2px;
}
.remove-authorization-title {
  color: #303133;
  line-height: 22px;
}
.remove-authorization-tip {
  color: #909399;
  font-size: 12px;
  margin-top: 6px;
}
.eldelefs {
  .el-col {
    min-height: 52px;
  }
}
</style>
